module.exports = __webpack_public_path__ + "static/media/21.087d5f06.png";